export function uid(prefix = '') {
  const raw =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
  return prefix ? `${prefix}_${raw}` : raw
}

/**
 * An id made from a name: the same on every device, so two devices that make
 * the category "Food" apart make the same row, and syncing merges them rather
 * than finding two rows with one unique name. Case folded, as the unique index
 * folds it. Two 32-bit FNV-1a hashes, differently seeded: 16 hex digits.
 */
export function nameId(prefix, name) {
  const text = String(name).trim().toLowerCase()
  let a = 0x811c9dc5
  let b = 0x01000193 ^ 0x5bd1e995
  for (let i = 0; i < text.length; i++) {
    const c = text.charCodeAt(i)
    a = Math.imul(a ^ c, 0x01000193) >>> 0
    b = Math.imul(b ^ c, 0x01000193) >>> 0
  }
  return `${prefix}_${a.toString(16).padStart(8, '0')}${b.toString(16).padStart(8, '0')}`
}
